<script>
    import IconReplace from '@/components/icon/IconReplace.vue';
    import { parseTags } from '@/api/tags.js';

    export default {
        computed: {
            gameID() {return this.$store.getters.CURRENT_GAME}
        },
        components: {
            IconReplace: IconReplace,
        },
        methods: {
            async parse() {
                const response = await parseTags(
                    await this.$store.getters.ASSET_TYPE_IMAGES, 
                    this.gameID
                );
                if (response === true) this.$store.dispatch('UPDATE_FILES');
            }
        }
    }
</script>


<template>
    <button
        class="left_button_main_container"
        :disabled="gameID == null"
        @click="parse"
    >
        <div class="left_button_icon_container">
            <IconReplace 
                icon-height="16px"
                icon-width="16px"
            />
        </div>
        <div class="left_button_label_container">
            <label>Parse tags</label>
        </div>
    </button>
</template>